export function formatPrice(price) {
    if (typeof price === "string") Number(price);
    const rounded = Math.round(price);
    return rounded.toLocaleString("ru-RU") + " ₽";
}
